
const LandingPage = () => {

    return (
        <div className="parallax_view">
            <section id="main-section"
                     className="container d-flex align-items-center justify-content-center text-dark ">
                <div className="vertical-center">
                    <h1 className="font-link text-light h1 pb-3 fs-1 pt-3 text-center fw-bolder ">فــراد | فرا
                        رایانه آسان درمان</h1>
                    <h5 className="font-link text-light text-center pt-5-3 m-3 fw-bolder fs-3">تسهیل کننده راه درمان</h5>
                </div>
            </section>
        </div>
    );

}

export default LandingPage;